var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading_state),expression:"loading_state"}],staticClass:"loading"},[_c('a-spin',{attrs:{"size":"large","tip":_vm.loading_text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }